import { useState } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import images from '../utils/images';
const photos = [
    {
        src: images['photo.jpg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image3 (1).jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['photo2.jpg'],
        height: 4032,
        width: 3024
    },
    {
        src: images['image17.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['photo3.jpg'],
        height: 4032,
        width: 3024
    },
    {
        src: images['image4.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image5.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image6.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['photo4.jpg'],
        height: 4032,
        width: 3024
    },
    {
        src: images['image7.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['photo7.jpg'],
        height: 4032,
        width: 3024
    },
    {
        src: images['image18.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image16.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image19.jpeg'],
        height: 4032, 
        width: 3024
    },
{
        src: images['image2 (1).jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['photo10.jpg'],
        height: 4032,
        width: 3024
    },
    {
        src: images['image14.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image8.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['photo11.jpg'],
        height: 4032,
        width: 3024
    },

    {
        src: images['photo15.jpg'],
        height: 4032,
        width: 3024
    },
    {
        src: images['image9.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image10.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image11.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image12.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image13.jpeg'],
        height: 4032, 
        width: 3024
    },
    {
        src: images['image15.jpeg'],
        height: 4032, 
        width: 3024
    },
]
export default function PhotoGallery() {
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const handlePrevious = () => {
    setCurrentPhotoIndex((prevIndex) => Math.max(0, prevIndex - (window.innerWidth <= 320 ? 1 : 4)));
  };

  const handleNext = () => {
    setCurrentPhotoIndex((prevIndex) =>
      Math.min(photos.length - 1, prevIndex + (window.innerWidth <= 320 ? 1 : 4))
    );
  };
const visiblePhotos = photos.slice(currentPhotoIndex, currentPhotoIndex + 4);
  return (
    <div className="gallery-container">
      <div className="gallery">
        {visiblePhotos.map((photo, index) => (
          <div className="gallery-item" key={index} onClick={() => {
            setModalImage(photo.src);
            setIsModalOpen(true);
          }}>
            <img src={photo.src} alt={`Home result ${index + 1}`} />
          </div>
        ))}
      </div>

      <div className="navigation-buttons">
        {currentPhotoIndex > 0 && (
          <button className="navigation-arrow-left" onClick={handlePrevious}>
            <FaArrowLeft />
          </button>
        )}
        {currentPhotoIndex + 2 < photos.length && (
          <button className="navigation-arrow-right" onClick={handleNext}>
            <FaArrowRight />
          </button>
        )}
      </div>
      {/* Modal Fullscreen View */}
{isModalOpen && (
  <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <img src={modalImage} alt="Full View" />

      {/* Navigation buttons inside modal */}
      <div className="modal-buttons">
        <button
          className="modal-nav-button left"
          onClick={() => {
            const currentIndex = photos.findIndex((p) => p.src === modalImage);
            if (currentIndex > 0) {
              setModalImage(photos[currentIndex - 1].src);
            }
          }}
        >
          <FaArrowLeft />
        </button>

        {/* Optional download button */}
        <a
          href={modalImage}
          download
          className="modal-download-button"
        >
          Download
        </a>
        <button
          className="modal-nav-button right"
          onClick={() => {
            const currentIndex = photos.findIndex((p) => p.src === modalImage);
            if (currentIndex < photos.length - 1) {
              setModalImage(photos[currentIndex + 1].src);
            }
          }}
        >
          <FaArrowRight />
        </button>
        {/* Close button */}
        <button className="close-button" onClick={() => setIsModalOpen(false)}>
          ×
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
}
